import React from "react"

import SelectTags from "../../../common/tags/SelectTags"

import ConceptMappingItem from "../../../common/concept-mappings/ConceptMappingItem"

const InsightAreaConceptMappingsEditWidget = ({
    onRemoveMapping,
    onConceptSearch,
    onAddMapping,
    mappings,
}) => {
    mappings = mappings.map((mapping) => ({
        ...mapping,
        fakeId:
            mapping.id ||
            mapping.positive.map(({ id }) => `pos-${id}`).join("-"),
    }))
    return (
        <div className="widget">
            <h3 className="widget-header">
                <span className="icon icon-concepts" />
                Mappings
            </h3>
            <hr />
            <div className="widget-content overflow">
                <div className="mapping-box clearfix">
                    {mappings.map((mapping) => (
                        <ConceptMappingItem
                            key={mapping.id || mapping.fakeId}
                            {...mapping}
                            onRemoveMapping={onRemoveMapping}
                        />
                    ))}
                    {mappings.length === 0 && "No mappings"}
                </div>
                <div className="mapping-build clearfix">
                    <h5>Add concepts</h5>
                    <SelectTags
                        name="concepts"
                        // value={mappingToBeAdded.positive}
                        loadOptions={onConceptSearch}
                        filterOption={() => true}
                        onChange={onAddMapping}
                        multi={false}
                    />
                </div>
                {/* Consider re-adding back the article preview when you make something based on fingerprints */}
                {/* {(mappingToBeDeleted ||
                    mappingToBeAdded.positive.length > 0) && (
                    <ConceptMappingPreview
                        previewMapping={mappingToBeDeleted || mappingToBeAdded}
                        isDeleting={mappingToBeDeleted !== null}
                        isFetching={isFetchingPreview}
                        afterCount={afterCount || 0}
                        beforeCount={beforeCount || 0}
                        after={after}
                    />
                )} */}
            </div>
        </div>
    )
}

export default InsightAreaConceptMappingsEditWidget
